angular.module('wco.directives.availableItemsArea', [])

.controller('WcoAvailableItemsAreaController', ['$scope', function($scope) {


}])
.directive('wcoAvailableItemsArea', ['$timeout', function($timeout) {
    return {
        controller: 'WcoAvailableItemsAreaController',
        controllerAs: 'availableItemsAreaController',
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || 'angular/directives/availableItemsArea.html';
        },
        replace: true,
        scope:{
            items: '='
        },
        link: function(scope, element, attrs, ngModelController) {
            if (typeof(window.__wco_vars) == 'undefined'){
                window.__wco_vars = {
                    scopes: {
                        packaging: {}
                    }
                }
            }
            window.__wco_vars.scopes.packaging.availableItems = scope;

            $(element).droppable({
                accept: ".packaged-draggable-item",
                activeClass: "ui-state-hover",
                hoverClass: "ui-state-active",
                drop: function( event, ui ) {
                    var itemId = $(ui.draggable[0]).data('itemId');
                    var packingId = $(ui.draggable[0]).data('packingId');


                    var currentScope = window.__wco_vars.scopes.packaging.availableItems;
                    currentScope.$emit('droppedPackagedItem', {itemId: itemId, packingId: packingId});
                }
            });
        }
    };
}]);